import { ComponentProps, ReactNode, useMemo } from 'react';

import { FlowChartWrapper } from '@/components/diagrams/FlowChart/components/FlowChartWrapper';

export interface EntityDiagramFlowChartWrapperProps {
  height: number;
  children: ReactNode;
  presentationMode?: boolean;
  hideBorder?: boolean;
}

export const EntityDiagramFlowChartWrapper = ({
  height,
  children,
  presentationMode = false,
  hideBorder = false,
}: EntityDiagramFlowChartWrapperProps) => {
  const variant: ComponentProps<typeof FlowChartWrapper>['variant'] =
    useMemo(() => {
      return presentationMode || hideBorder ? 'transparent' : 'outlined';
    }, [presentationMode, hideBorder]);

  return (
    <FlowChartWrapper style={{ height }} variant={variant}>
      {children}
    </FlowChartWrapper>
  );
};
